var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTrashcan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "22px",
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trashcan",
    transform: "translate(-8.000000, -5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.307,8.098 L17.693,8.098 L17.693,6.969 L14.307,6.969 L14.307,8.098 Z M23.337,8.098 L23.337,11.485 L8.663,11.485 L8.663,8.098 L13.178,8.098 L13.178,6.969 L14.307,5.841 L17.693,5.841 L18.822,6.969 L18.822,8.098 L23.337,8.098 Z M22.208,26.159 L9.792,26.159 L9.792,12.614 L12.049,12.614 L12.049,23.902 L13.178,23.902 L13.178,12.614 L15.436,12.614 L15.436,23.902 L16.564,23.902 L16.564,12.614 L18.822,12.614 L18.822,23.902 L19.951,23.902 L19.951,12.614 L22.208,12.614 L22.208,26.159 Z",
    id: "Fill-2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrashcan);
export default __webpack_public_path__ + "static/media/ic_trashcan.3e412484cc807e32d60574f0744b9ea6.svg";
export { ForwardRef as ReactComponent };